module.exports = __webpack_public_path__ + "static/vendor-analytic-dashboard-1f1ef6f48ead4278dc412f3b2fc0cc29.png";